import { Button } from '@cocoonspace/ui/components/button'
import { FormControlledInput } from '@cocoonspace/ui/components/form-controlled-input'
import { Input } from '@cocoonspace/ui/components/input'
import { Textarea } from '@cocoonspace/ui/components/textarea'
import { useLingui } from '@lingui/react/macro'
import { ArrowLeftIcon } from 'lucide-react'

import { useAnswerCard } from './provider'

export const Validation = () => {
	const { t } = useLingui()
	const { setStep } = useAnswerCard()

	return (
		<div className='flex min-w-0 flex-col border-t p-6 md:border-t-0 md:border-l md:p-8'>
			<div className='grid grid-cols-2 gap-4'>
				<FormControlledInput
					label={`${t`Prénom`} *`}
					name='additionalInfos.first_name'
					render={({ field }) => <Input {...field} />}
				/>

				<FormControlledInput
					label={`${t`Nom`} *`}
					name='additionalInfos.last_name'
					render={({ field }) => <Input {...field} />}
				/>
			</div>

			<FormControlledInput
				label={`${t`Email`} *`}
				name='email'
				render={({ field }) => <Input {...field} />}
			/>

			<FormControlledInput
				label={t`Commentaire`}
				name='additionalInfos.comment'
				render={({ field }) => <Textarea {...field} />}
			/>

			<div className='flex flex-col gap-2 md:grid md:grid-cols-2 md:gap-4'>
				<Button
					type='submit'
					// size='sm'
					className='md:order-1'
				>
					{t`Valider`}
				</Button>

				<Button
					type='button'
					variant='link'
					size='sm'
					className='md:order-0'
					onClick={() => setStep('dateTime')}
				>
					<ArrowLeftIcon />
					{t`Retour`}
				</Button>
			</div>
		</div>
	)
}
